import script from "./StatsModeShareBehaviorQuery.vue?vue&type=script&lang=js"
export * from "./StatsModeShareBehaviorQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__